module.exports = __webpack_public_path__ + "img/alertimage.4ae9f045.svg";